import React from "react";
import {CardBody, CardText, CardTitle} from "reactstrap";
import {FaThumbsDown, FaThumbsUp} from "react-icons/fa";

export const OrganizationCard = ({data}) => {
  const {name, slug, total_system, is_active} = data;
  return (
    <CardBody>
      <CardTitle tag="h3">
        <div>{name}</div>
        <div>
          <small>(Slug: {slug})</small>
        </div>
      </CardTitle>
      <CardText>
        <div>
          <span style={{marginRight: "10px"}}>Active</span>
          {is_active ? (
            <FaThumbsUp className="text-green" />
          ) : (
            <FaThumbsDown className="text-red" />
          )}
        </div>
        <div>Total Systems: {total_system}</div>
      </CardText>
    </CardBody>
  );
};
